import { render, staticRenderFns } from "./invit.vue?vue&type=template&id=07ef5e02&scoped=true&"
import script from "./invit.vue?vue&type=script&lang=js&"
export * from "./invit.vue?vue&type=script&lang=js&"
import style0 from "./invit.vue?vue&type=style&index=0&id=07ef5e02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ef5e02",
  null
  
)

export default component.exports